import React, { useEffect, useRef } from 'react';
import Chart from 'chart.js/auto';

const PresentChart = ({ attendees }) => {
  const chartRef = useRef();
  const chartInstance = useRef(null);

  useEffect(() => {
    if (chartInstance.current) {
      chartInstance.current.destroy();
    }

    const presents = {};

    attendees.forEach((attendee) => {
      presents[attendee.present] = (presents[attendee.present] || 0) + 1;
    });

    const ctx = chartRef.current.getContext('2d');
    const labels = Object.keys(presents).map((present) => `${present} (${presents[present]})`);
    chartInstance.current = new Chart(ctx, {
      type: 'pie',
      data: {
        labels,
        datasets: [
          {
            label: 'Present Distribution',
            data: Object.values(presents),
            backgroundColor: ['midnightblue', 'lightblue'], // Colors for male and female
          },
        ],
      },
      options: {
        plugins: {
          legend: {
            display: true,
            position: 'right',
          },
          tooltip: {
            callbacks: {
              label: (context) =>
                 `${context.label}: ${context.parsed} (${(
                  (context.parsed / context.dataset.data.reduce((a, b) => a + b, 0)) *
                  100
                ).toFixed(2)}%`,
            },
          },
        },
      },
    });

    return () => {
      if (chartInstance.current) {
        chartInstance.current.destroy();
      }
    };
  }, [attendees]);

  return <canvas ref={chartRef} />;
};

export default PresentChart;
